import {AfterViewInit, Directive, OnDestroy, TemplateRef, ViewContainerRef} from "@angular/core";

@Directive({
  selector: '[intInsertAfterViewInit]'
})
export class IntInsertAfterViewInitDirective implements OnDestroy, AfterViewInit{
  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainerRef: ViewContainerRef
  ) {
  }

  ngOnDestroy() {
    this.viewContainerRef.clear();
  }

  ngAfterViewInit() {
    this.viewContainerRef.createEmbeddedView(this.templateRef);
  }
}
